// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import DigitalWill from './App'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '.interactives-digital-will',
  template: '<DigitalWill/>',
  components: { DigitalWill }
})



// WEBPACK FOOTER //
// ./src/main.js